import React from 'react';
import { AddOnsActionContextProvider } from './add-ons-action-context';

import { AddOnMarketplace } from './add-on-marketplace-page';

export const AddOnMarketplaceWrapper = () => {
  return (
    <AddOnsActionContextProvider>
      <AddOnMarketplace />
    </AddOnsActionContextProvider>
  );
};
